export default "__VITE_ASSET__KsL6v4XD__"